import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Subject } from 'rxjs';
import { ApiService } from './api.service';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

const INITIAL_VALUES = {
  PageNo: 1,
  skuId: [],
  brandId: [],
  pcId: [],
  itemId: [],
};
@Injectable({
  providedIn: 'root',
})
export class UserService {
  reset() {
    this.apiKey = null;
    this.filter.next(INITIAL_VALUES);
    this.map.next(null);
    this.userData.next({});
  }
  apiKey;

  filter = new BehaviorSubject<any>(INITIAL_VALUES);
  // userSubject = new BehaviorSubject<any>();
  map = new Subject<any>();
  setApikey(apikey: any) {
    this.apiKey = apikey;
  }
  constructor(
    public http: ApiService,
    public httpclient: HttpClient
  ) {}
  userData = new BehaviorSubject<any>({});
  getVolatileData() {
    return this.http.get('retailers/reloadOperation');
  }
  setUserData(data) {
    this.userData.next(data);
  }
  setFilter(obj, reset = false) {
    const data = reset ? INITIAL_VALUES : this.filter.value;
    console.log('mydata', obj);
    this.filter.next({ ...data, ...obj, reset });
  }
  decodeAddress = (arr, type) => {
    console.log(arr, type);

    return arr
      .reverse()
      .reduce((p, c) => (c.types.includes(type) ? c.long_name : p), '');
  };
  // async showToast({ message, color }: ToastOptions) {
  //   const toast = await this.toastController.create({
  //     message,
  //     duration: 3000,
  //     color,
  //   });
  //   toast.present();
  // }
  getUserData() {
    this.http.get('retailers/reloadOperation').subscribe((res) => {
      console.log(res);
    });
  }

  getProfileDetails(url, options?) {
    return this.httpclient.get(environment.baseURL + url, options);
  }
}
